if (!customElements.get("product-gallery")) {
  class a extends HTMLElement {
    constructor() {
      (super(),
        (this.media = window.matchMedia("(min-width: 992px)")),
        this.media.addEventListener("change", () => this.onResize()),
        (this.swiper = void 0),
        this.listen(),
        this.onResize(),
        (this._variantChangeHandler = (e) => {
          (this.classList.add("loading"),
            fetch(
              `/products/${e.detail.product}?variant=${e.detail.variant}&view=gallery`,
            )
              .then((e) => e.text())
              .then((e) => {
                e = new DOMParser().parseFromString(e, "text/html");
                e.querySelector("product-gallery") &&
                  ((this.querySelector(".swiper-container").innerHTML =
                    e.querySelector(
                      "product-gallery .swiper-container",
                    ).innerHTML),
                  this.swiper && this.swiper.destroy(!0, !0),
                  (this.swiper = void 0),
                  this.listen(),
                  this.onResize(),
                  Promise.all(
                    Array.from(
                      this.querySelectorAll(".swiper-container img"),
                    ).map((img) =>
                      img.complete
                        ? Promise.resolve()
                        : new Promise((resolve) => {
                            img.addEventListener("load", resolve, {
                              once: true,
                            });
                            img.addEventListener("error", resolve, {
                              once: true,
                            });
                          }),
                    ),
                  ).then(() => {
                    this.swiper && this.swiper.update();
                  }),
                  setTimeout(() => {
                    (this.classList.remove("loading"),
                      window.dispatchEvent(new Event("resize")),
                      this.swiper && this.swiper.update());
                  }, 1e3));
              })
              .catch((e) => {
                setTimeout(() => {
                  this.classList.remove("loading");
                }, 1e3);
              }));
        }),
        window.addEventListener("variantChange", this._variantChangeHandler));
    }
    disconnectedCallback() {
      if (this._variantChangeHandler) {
        window.removeEventListener("variantChange", this._variantChangeHandler);
      }
      if (this._videoObserver) {
        this._videoObserver.disconnect();
      }
    }
    hydrateVideo(e, t = false) {
      if (!e || e.dataset.videoLoaded === "true") return;
      e.querySelectorAll("source[data-src]").forEach((e) => {
        e.src = e.dataset.src;
        e.removeAttribute("data-src");
      });
      e.dataset.videoLoaded = "true";
      e.load();
      if (t || e.hasAttribute("autoplay")) {
        e.play().catch(() => {});
      }
    }
    observeVideos() {
      if (this._videoObserver) {
        this._videoObserver.disconnect();
      }
      const e = this.querySelectorAll("video[data-lazy-video]");
      if (!e.length) return;
      if (!("IntersectionObserver" in window)) {
        e.forEach((e) => this.hydrateVideo(e));
        return;
      }
      this._videoObserver = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            if (!e.isIntersecting) return;
            this.hydrateVideo(e.target);
            this._videoObserver.unobserve(e.target);
          });
        },
        { rootMargin: "400px 0px" },
      );
      e.forEach((e) => this._videoObserver.observe(e));
    }
    listen() {
      (this.dataset.paginationEnable !== "false" &&
        this.querySelectorAll(".product__gallery-button button").forEach(
          (e) => {
            (12 < this.querySelectorAll(".swiper-slide").length &&
              (e.parentElement.style.display = "block"),
              e.addEventListener("click", () => {
                (this.querySelectorAll(".swiper-slide").forEach(
                  (e) => (e.style.display = "block"),
                ),
                  (e.parentElement.style.display = "none"),
                  setTimeout(() => {
                    window.dispatchEvent(new Event("resize"));
                  }));
              }));
          },
        ),
        // this.querySelectorAll("video").forEach((e) => {
        //   (e.addEventListener("mouseenter", () => {
        //     e.play();
        //   }),
        //     e.addEventListener("mouseleave", () => {
        //       e.pause();
        //     }));
        // }),
        setTimeout(() => {
          this.classList.remove("loading");
        }, 500));
      this.observeVideos();
    }
    onResize() {
      this.media.matches
        ? void 0 !== this.swiper &&
          (this.swiper.destroy(), (this.swiper = void 0))
        : void 0 === this.swiper &&
          (this.swiper = new Swiper(this.querySelector(".swiper-container"), {
            loop: !0,
            grabCursor: !1,
            speed: 500,
            spaceBetween: 0,
            slidesPerView: "auto",
            watchSlidesProgress: !0,
            scrollbar: {
              el: this.querySelector(".swiper-scrollbar"),
              enabled: !0,
            },
            breakpoints: { 768: { slidesPerView: "auto", spaceBetween: 16 } },
            on: {
              slideChangeTransitionEnd: function () {
                this.scrollbar && this.scrollbar.updateSize();
              },
            },
          }));
    }
  }
  customElements.define("product-gallery", a);
}
